import styled from 'styled-components'
import { PersonAvatar } from '@sketch/components'

export const AvatarTitle = styled.div`
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.foreground.primary.B};
`

export const AvatarTooltipWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }

  ${PersonAvatar} {
    margin-right: 8px;
  }
`

export const PersonName = styled.span`
  max-width: min(300px, 80vw);

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`
